import React, { useState } from 'react';
import { Pagination as Pager } from 'antd';
import './styles.css';

function Pagination({ total, pageSize, onChange, id, pageNo }) {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className={'pagination-wrapper'} id={id}>
      <Pager
        total={total}
        pageSize={pageSize}
        onChange={(page) => {
          setCurrentPage(page);
          onChange(page);
        }}
        current={pageNo || currentPage}
        showSizeChanger={false}
      />
    </div>
  );
}

export default Pagination;
